import React from 'react';
import { Stats } from '../../types';
import './StatsCards.css';

interface StatsCardsProps {
  stats: Stats;
}

const StatsCards: React.FC<StatsCardsProps> = ({ stats }) => {
  const cards = [
    { title: 'Total Calls', value: stats.totalCalls, icon: '📞', color: '#3498db' },
    { title: 'Total Conversations', value: stats.totalConversations, icon: '💬', color: '#2ecc71' },
    { title: 'Transcriptions', value: stats.totalTranscriptions, icon: '📝', color: '#e74c3c' },
  ];

  return (
    <div className="stats-container">
      {cards.map((card, index) => (
        <div key={index} className="stat-card" style={{ borderBottom: `4px solid ${card.color}` }}>
          <div className="stat-icon">{card.icon}</div>
          <div className="stat-content">
            <h3>{card.title}</h3>
            <p className="stat-value">{card.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;